import styled, { css } from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';
import { mediaQuery } from '../../../utils/styles';

const skeletonBase = css`
  border-radius: ${toRem(8)};
`;

const spacing = {
  sm: toRem(16),
  md: toRem(24),
} as const;

export const InfoBlockLoaderWrapper = styled.div`
  margin-block: ${spacing.sm};

  .info-block_header,
  .info-block_subheader,
  .info-block_card {
    ${skeletonBase}
  }

  .info-block_header {
    width: ${toRem(400)};
    height: ${toRem(45)};
    margin-bottom: ${spacing.md};

    @media ${mediaQuery.mobileOnly} {
      width: 70%;
      height: ${toRem(33)};
    }
  }

  .info-block_subheader {
    width: ${toRem(300)};
    height: ${toRem(25)};
    margin-bottom: ${spacing.md};

    @media ${mediaQuery.mobileOnly} {
      width: 60%;
      height: ${spacing.sm};
      margin-bottom: ${spacing.sm};
    }
  }

  .info-block_container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: ${spacing.sm};

    @media ${mediaQuery.mobileOnly}, ${mediaQuery.tabletOnly} {
      grid-template-columns: 1fr;
    }
  }

  .info-block_card {
    height: ${toRem(150)};

    @media ${mediaQuery.mobileOnly} {
      height: ${toRem(100)};
    }
  }
`;
